import { Injectable, inject } from '@angular/core';
import { BaseQueryRepository } from '@okcargo-apps/shared-infrastructure';
import {
  ContactResponse,
  CountContactsQuery,
  CountContactsQueryHandler,
  CountResponse,
  FindContactQuery,
  FindContactQueryHandler,
  SearchContactsQuery,
  SearchContactsQueryHandler,
} from '@okcargo/query-processor';

@Injectable({
  providedIn: 'root',
})
export class ContactQueryService {
  private readonly queryRepository = inject(BaseQueryRepository);

  private readonly countContactsQueryHandler: CountContactsQueryHandler;
  private readonly searchContactsQueryHandler: SearchContactsQueryHandler;
  private readonly findContactQueryHandler: FindContactQueryHandler;

  constructor() {
    const queryRepository = this.queryRepository;

    this.countContactsQueryHandler = new CountContactsQueryHandler(queryRepository);
    this.searchContactsQueryHandler = new SearchContactsQueryHandler(queryRepository);
    this.findContactQueryHandler = new FindContactQueryHandler(queryRepository);
  }

  public countContacts(query: CountContactsQuery): Promise<CountResponse> {
    return this.countContactsQueryHandler.handle(query);
  }

  public searchContacts(query: SearchContactsQuery): Promise<ContactResponse[]> {
    return this.searchContactsQueryHandler.handle(query);
  }

  public findContact(query: FindContactQuery): Promise<ContactResponse> {
    return this.findContactQueryHandler.handle(query);
  }
}
